import MapComponent from "../components/Map";
import LatestGoogleReviewCard from "../components/Reviews";

const About = () => {
  return (
    <section id="about" className="about-container page-section">
      <div className="about-info">
        <h2>
          INSTAGRAM <br></br> weareyourlastresort <br></br>
          <br></br>
          TIKTOK <br></br> @weareyourlastresort{" "}
        </h2>
        <h2>
          Ping an email to <br></br> rugglers.pubs@gmail.com
        </h2>
        <h2>
          Give us a bell on <br></br> 07504 520946
        </h2>
        <h2>
          Direct your carrier pigeon to <br></br> 174 Heaton Road, Newcastle,
          NE6 5HP{" "}
        </h2>{" "}
      </div>
      <div className="about-map">
        <MapComponent />
      </div>
      <div className="review-container">
        <LatestGoogleReviewCard />
        <h2>
          <a
            className="review-link"
            href="https://www.google.co.uk/maps/place/The+Last+Resort/@54.9835107,-1.5842476,17z/data=!4m8!3m7!1s0x487e71b9af55bab1:0x13d79678d43a312!8m2!3d54.9835076!4d-1.5816727!9m1!1b1!16s%2Fg%2F11whwxl863?entry=ttu&g_ep=EgoyMDI1MDQyNy4xIKXMDSoASAFQAw%3D%3D"
          >
            Leave a Review
          </a>
        </h2>
      </div>
    </section>
  );
};

export default About;
